import { createSlice } from "@reduxjs/toolkit"

const initialState = {
  visible: false,
  redirectConfig: {},
  forceCloseWindow: false,
}

const slice = createSlice({
  initialState,
  name: "suitabilityModal",
  reducers: {
    showSuitabilityRequiredModal: (state, { payload }) => {
      state.visible = true
      state.redirectConfig = payload?.redirectConfig ?? {}
      state.forceCloseWindow = payload?.forceCloseWindow
    },
    hideSuitabilityRequiredModal: () => ({...initialState}),
  },
});

export const {
  showSuitabilityRequiredModal,
  hideSuitabilityRequiredModal,
} = slice.actions;

export default slice;